module.exports = __webpack_public_path__ + "img/logo.acace267.png";